module.exports = __webpack_public_path__ + "static/media/logo_verde.f3fe4b2b.png";